import { defineMessages } from "react-intl";

const PREFIX = "BulkExportPage";
export const messages = defineMessages({
  titlePage: {
    id: `${PREFIX}.titlePage`,
    defaultMessage: "Bulk export",
  },
});
